import { combineEpics } from 'redux-observable';
import { from, of, iif, empty, EMPTY } from 'rxjs';
import { catchError, filter, map, switchMap, tap, take } from 'rxjs/operators';
import { RootEpic } from 'store/types';
import { isActionOf } from 'typesafe-actions';
import { loadMonProfilInfosAsync } from './actions';
import { push } from 'connected-react-router';


const loadMonProfilInfosEpics: RootEpic = (action$, state$, { parametresService }) => action$.pipe(
    filter(isActionOf(loadMonProfilInfosAsync.request)),
    switchMap(() => from(parametresService.loadMonProfilInfos()).pipe(
        map(loadMonProfilInfosAsync.success),
        catchError(message => of(loadMonProfilInfosAsync.failure(message))),
    )),
);



const MonProfilEpics = combineEpics(
    loadMonProfilInfosEpics
);

export default MonProfilEpics;
